module.exports = new __parcel__URL__("dev-summary-create-branch-popup.tpl.37139a68.svg").toString();